const checkIsInRNWebView = () => {
  if (typeof window === 'undefined') {
    return false;
  }
  return !!window.ReactNativeWebView;
};

export default checkIsInRNWebView;
